import React from 'react'
import { Col, Row } from 'react-bootstrap'
import logo from '../../../public/assets/logo-primary.svg'
import styles from "./footer.module.css"
import email from '../../../public/assets/mail.png'
import hotline from '../../../public/assets/hotline.svg'
import { useMyContext } from '../../../myContext'

function Footer() {
  const {siteDisclaimerLink, partnerEmail, contactNumber} = useMyContext();
  return (
    <div style={{backgroundColor: "#0E0E0E", overflow: "hidden"}}>
      <div className={styles.outerRow}>
      <Row style={{width: "fit-content"}}><img src={logo} alt="logo" style={{height: "36px", marginBottom: "15px"}}></img></Row>
    <Row>
        <Col md={4}>
        <p className={styles.description}>©Borderless Softtech Pvt Ltd, a subsidiary of Borderless Investing Inc. {new Date().getFullYear()}</p>
        </Col>
        <Col md={8} className={styles.innerCol}>
        <Row style={{display: "flex", flexDirection: "column"}}>
            <p className={styles.parafirst}>Learn More</p>
            <a className={styles.parasecond} style={{textDecoration: "none", color: "white", cursor: "pointer"}}
            href={siteDisclaimerLink}
            target="_blank" rel="noopener noreferrer"> User Agreement</a>
            {/* <p className={styles.parasecond}>User Agreement</p> */}
        </Row>
        <Row style={{display: "flex", flexDirection: "column"}}>
            <p className={styles.parafirst}>Contact us</p>
            <p className={styles.parasecond}> <img src={email} className={styles.hotlineImage} alt="email" /> {partnerEmail}</p>
            <p className={styles.parasecond}> <img src={hotline} className={styles.hotlineImage} alt="phone" /> {contactNumber}</p>
        </Row>
        {/* <Row style={{display: "flex", flexDirection: "column"}}>
            <p className={styles.parafirst}>Follow Us</p>
            <p className={styles.imagePara} style={{padding: "0px"}}><img src={fb} alt="fb" /> <img src={twitter} alt="twitter" /> <img src={insta} alt="insta" /> <img src={linkedin} alt="linkedin" /></p>
        </Row> */}
        </Col>
    </Row>
    </div>
    <Row className={styles.bottomText}>
    Borderless Softtech Pvt Ltd, a subsidiary of Borderless Investing Inc. All Rights Reserved. | All Rights Reserved | Copyright © 2010 — {new Date().getFullYear()}
    </Row>
    <hr className={styles.footerDivider} />

    <div className={styles.disclaimerSection}>
      <p>Borderless Investing Inc., (“Borderless Investing”), the owner of the Borderless digital platform (“Borderless”), is not a broker-
        dealer nor an investment advisor and through its subsidiary stockbroker Stockal Securities Pvt. Ltd., (SEBI INZ000301236), acting 
        as the introducing entity has entered into a clearing agreement with DriveWealth LLC.,* to offer U.S. equities on its investing 
        platform (“Borderless”) (formerly “Stockal"). Borderless also partners with Airwallex** and its underlying banking partner(s) 
        pursuant to a master services agreement, to enable investments across diverse global assets through a single account.  As such, 
        Borderless Investing makes no warranties or representations, express or implied, on products and services offered through its 
        website/platform. It accepts no liability for any damages or losses, however, caused in connection with the use of related 
        services.</p>

      <div className={styles.footerLinks}>
        <div className={styles.linkItem}>
          <a
            href="https://help.stockal.com/portal/en/kb/articles/investing"
            target="_blank"
            rel="noopener noreferrer"
          >
            Investing
          </a>
        </div>

        <div className={styles.linkItem}>
          <a
            href="https://help.stockal.com/portal/en/kb/articles/savings-4-11-2025"
            target="_blank"
            rel="noopener noreferrer"
          >
            Savings
          </a>
        </div>

        <div>
          <a
            href="https://help.stockal.com/portal/en/kb/articles/payments-4-11-2025"
            target="_blank"
            rel="noopener noreferrer"
          >
            Payments
          </a>
        </div>
      </div>

      <p>
        *DriveWealth LLC., a member of the Securities Investor Protection Corporation (SIPC), will serve as the custodian for your securities account. In the event that DriveWealth LLC., fails and is placed in liquidation under the Securities Investor Protection Act, securities in your brokerage account may be protected up to $500,000. For details, please see {" "}
        <a
          href="https://www.sipc.org"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.sipcLink}
        >
          www.sipc.org
        </a>
      </p>

      <p>**Airwallex is a regulated multinational financial technology company offering a platform that provides cross-border payments and financial services to businesses through a proprietary banking network and its Application Programming Interface (“API”).</p>
      <p>All brands and logos used on this website are the property of their respective owners. The trademarks, images and logos used 
    herein are only for information purposes.</p>
    </div>

    <hr className={styles.footerDivider} />
    </div>
  )
}

export default Footer